import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=b2311008&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=b2311008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2311008",
  null
  
)

export default component.exports